export interface AccessToken {
  tkn: string;
}

export enum TokenAction {
  UPLOAD = 20,
  DOWNLOAD = 30,
}
